import { gsap } from "gsap";


export const Ui = {
  ready:()=>{
    gsap.to(".trigger-inner",1.4,{ease:"Power2.easeOut",y:0,autoAlpha:1});
    gsap.to(".logo",1.4,{ease:"Power3.easeOut",y:0,autoAlpha:1});
    gsap.to(".PC .sns",1.4,{ease:"Power3.easeOut",x:0});
  },
  uiOff:()=>{
    gsap.to(".trigger-inner",.8,{ease:"Power2.easeOut",y:-20,autoAlpha:0});
    gsap.to(".logo",.8,{ease:"Power3.easeOut",y:-20,autoAlpha:0});
    gsap.to(".PC .sns",.8,{ease:"Power3.easeOut",x:-60});
    gsap.to(".frame-rightTop", 3,{autoAlpha:0,ease:'Power3.easeOut',x:30,y:-20})
  }
};
